/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 17/11/2017.
*
* login-form Vue Component
*/
<template>
  <div class="login-form">
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      label-position="top"
      @submit.native.prevent="onSubmit"
    >
      <main>
        <h1>Bienvenido</h1>

        <el-form-item
          prop="username"
        >
          <el-input
            placeholder="Usuario"
            v-model="model.username"
            prefix-icon="icon-person_outline"
          />
        </el-form-item>
        <el-form-item
          prop="password"
        >
          <el-input
            placeholder="Contraseña"
            v-model="model.password"
            type="password"
            prefix-icon="icon-lock_outline"
          />
        </el-form-item>
        <el-checkbox v-model="model.rememberMe">Recordar mi sesión</el-checkbox>
      </main>
      <footer>
        <el-row>
          <el-col :span="24">
            <el-button
              native-type="submit"
              class="el-button--block"
              type="primary"
            >Iniciar Sesión
            </el-button>
          </el-col>
        </el-row>
      </footer>
    </el-form>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import Login from './login.model'

export default {
  name: 'LoginForm',
  // Variables
  data () {
    return {
      model: Login.model(),
      rules: Login.rules,
      invalidCredentials: false
    }
  },
  methods: {
    onSubmit (event) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('onSubmit', this.model)
        } else {
          this.$emit('onError')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss">
  .login-form {
    .el-button--block {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/login/login-form.vue